import { createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/logo-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-a0d4dca8")

_pushScopeId("data-v-a0d4dca8")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-md-center" }
const _hoisted_3 = { class: "col-lg-4 col-md-6 col-sm-12 resend-form text-white" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "col" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      class: "img-fluid",
      alt: "Responsive image"
    })
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"form-group\" data-v-a0d4dca8><div class=\"row justify-content-between\" data-v-a0d4dca8><div class=\"col\" data-v-a0d4dca8><label class=\"text-muted h5 mb-4\" data-v-a0d4dca8> Welcome to Satstreet, thanks for signing up! </label><button type=\"submit\" class=\"btn btn-primary\" data-v-a0d4dca8> Resend the Confirmation Email </button></div></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("form", {
              id: "resend",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
            }, [
              _hoisted_8
            ], 32)
          ])
        ])
      ])
    ])
  ]))
})